exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---web-app-base-src-templates-page-template-tsx": () => import("./../../../../web-app-base/src/templates/pageTemplate.tsx" /* webpackChunkName: "component---web-app-base-src-templates-page-template-tsx" */)
}

